<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import Loader from "@/components/widgets/preloader";
import { mapGetters, mapActions, mapState } from "vuex"
import Swal from "sweetalert2";
import moment from "moment";


/**
 * Advanced table component
 */
export default {
  page: {
    title: "Debtors",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    Loader,
  },
  data() {
    return {
      title: "Credit Sales",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Debtors",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      clear: {
        id: "",
        date: moment(new Date()).format("YYYY-MM-DD"),
        paid: "",
        mode: "",
        totals: "",
      },

      data: {
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        customer: "",
        branch_id: 0
      },
      amountError: "",
      modeError: "",
      balance: 0,
      SaveStatus: this.SaveStatus,
      totals: {
        totalAmount: 0,
        totalPaid: 0,
        totalDiscount: 0,
        totalBalance: 0,
      },

      edit: {
        id: '',
        name: '',
        pay_date: '',
      }

    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("saledetails", ["SaveStatus", "Debtors", "filterStatus"]),
    ...mapGetters("setting", ["PaymentOptions", "GeneralSettings", "ReceiptSettings"]),
    ...mapGetters("auth", ["MyUserPerm", "business", "branch", "Branches", "branchid"]),
    ...mapGetters("customers", ["Customers"]),
    ...mapState("saledetails", ["saleId"]),

    fields() {
      let baseFields = [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "cust",
          sortable: true,
          label: "CUSTOMER",
        },
        {
          key: "tt_amt",
          sortable: true,
          label: "TOTAL",
        },
        {
          key: "amt_paid",
          sortable: true,
          label: "PAID",
        },
        {
          key: "discount_field",
          sortable: true,
          label: "DISCOUNT",
        },
        {
          key: "balance",
          sortable: true,
          label: "BALANCE",
        },
        {
          key: "receipt",
          sortable: true,
          label: "RECEIPT",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "user",
          sortable: true,
          label: "RECORDED BY",
        },
        {
          key: "details",
          sortable: true,
          label: "PRODUCTS",
        },
        {
          key: "actions",
          sortable: false,
          label: "ACTION",
        },
      ];
      if (this.GeneralSettings.set_debtpay_date != 0) {
        baseFields.splice(7, 0,
          {
            key: "pay_date",
            sortable: true,
            label: "EXPECTED PAY DATE",
          },
          {
            key: "remaining_days",
            sortable: true,
            label: "DAYS REMAINING",
          },
        );
      }
      if (this.branchid == 0) {
        baseFields.splice(9, 0,
          {
            key: "branch.name",
            sortable: true,
            label: "BRANCH",
          }
        );
      }
      return baseFields;
    },

    /**
     * Total no. of records
     */

    rows() {
      return this.Debtors ? this.Debtors.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Debtors ? this.Debtors.length : 1;
  },

  watch: {
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
    saleId(newValue) {
      if (newValue && this.ReceiptSettings.print_receipt_after_sale == 1) {

        if (this.ReceiptSettings.receipt_type == 1) {
          window.open(
            `https://${window.location.host}/receipts/debtreceipt.php?id=${btoa(newValue)}`
          );
        } else if (this.ReceiptSettings.receipt_type == 2) {
          window.open(
            `https://${window.location.host}/receipts/debtreceiptv2.php?id=${btoa(newValue)}`
          );
        } else if (this.ReceiptSettings.receipt_type == 3) {
          window.open(
            `https://${window.location.host}/receipts/debtreceiptv3.php?id=${btoa(newValue)}`
          );
        }
        else if (this.ReceiptSettings.receipt_type == 4) {
          window.open(
            `https://${window.location.host}/receipts/debtreceiptv4.php?id=${btoa(newValue)}`
          );
        } else {
          window.open(
            `https://${window.location.host}/receipts/debtreceipt.php?id=${btoa(newValue)}`
          );
        }
      }
    },
    PaymentOptions(newValue) {
      if (newValue) {
        this.setDefaultMode();
      }
    },

    Debtors(newValue) {
      if (newValue) {
        this.setDebtorsData();
      }
    },
  },
  methods: {
    ...mapActions({
      FetchDebtors: "saledetails/fetchDebtors",
      ClearBalance: "saledetails/ClearDebt",
      ClearBalancePrint: "saledetails/ClearDebtPrint",
      FetchModes: "setting/fetchPaymentOptions",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchReceiptSettings: "setting/fetchReceiptSettings",
      FetchCustomers: "customers/fetchCustomers",
      editPaydate: "saledetails/editPaydate",

    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    setDefaultMode() {
      let defaultop = this.PaymentOptions ? this.PaymentOptions : [].filter((mode) => {
        return mode.default == 1;
      })
      this.clear.mode = defaultop[0] ? defaultop[0].id : 0;
    },
    resetModal() {
      this.clear.id = "";
      this.clear.paid = "";
      this.setDefaultMode();
      this.clear.total = "";
    },
    resetError() {
      this.amountError = "";
      this.modeError = "";
    },
    addCommas() {
      this.clear.paid = this.thousandSeperator(this.clear.paid);
    },
    ShowClear(data) {
      this.clear.id = data.id;
      this.balance = data.balance;
      this.clear.paid = (data.totalAmt - (data.totalPaid - data.discount)).toLocaleString();
      this.clear.total = data.totalAmt;
    },
    checkAmt() {
      if (this.clear.paid.replace(/,/g, '') > this.balance && this.GeneralSettings.deposit_balances == 0) {
        this.amountError = "Amount Paid is greater than balance";
        return
      }
      else {
        this.amountError = "";
      }
    },
    clearAmt(modalId) {
      this.modal_id = modalId;
      if (this.clear.paid == "") {
        this.amountError = "Amount Paid is required";
        return
      }
      else {
        this.amountError = "";
      }
      if (this.clear.paid.replace(/,/g, '') > this.balance && this.GeneralSettings.deposit_balances == 0) {
        this.amountError = "Amount Paid is greater than balance";
        return
      }
      else {
        this.amountError = "";
      }
      if (this.clear.mode == "") {
        this.modeError = "Payment Method is required";
        return
      }
      else {
        this.modeError = "";
      }
      this.SaveStatus = true;
      this.ClearBalance(this.clear).then(() => {
        this.SaveStatus = false;
        this.FetchDebtors(this.data);
        this.closeModal(modalId);
      });
    },

    clearAmtPrint(modalId) {
      this.modal_id = modalId;
      if (this.clear.paid == "") {
        this.amountError = "Amount Paid is required";
        return
      }
      else {
        this.amountError = "";
      }
      if (this.clear.paid.replace(/,/g, '') > this.clear.total && this.GeneralSettings.deposit_balances == 0) {
        this.amountError = "Amount Paid is greater than balance";
        return
      }
      else {
        this.amountError = "";
      }
      if (this.clear.mode == "") {
        this.modeError = "Payment Method is required";
        return
      }
      else {
        this.modeError = "";
      }
      this.SaveStatus = true;
      this.ClearBalancePrint(this.clear).then(() => {
        this.SaveStatus = false;
        this.FetchDebtors(this.data);
        this.closeModal(modalId);
      });
    },

    closeModal(modalId) {
      this.resetError();
      this.resetModal();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
    filterReport() {
      this.FetchDebtors(this.data);
      this.setDefaultMode();
    },

    handleUpload() {
      this.file = this.$refs.file.files[0];
    },

    setDebtorsData() {
      let total_amount = 0;
      let total_paid = 0;
      let total_discount = 0;
      this.Debtors.forEach((item) => {
        total_amount = total_amount + parseInt(item.totalAmt);
        total_paid = total_paid + parseInt(item.totalPaid);
        total_discount = total_discount + parseInt(item.discount);

        this.totals.totalBalance = this.totals.totalAmount - (this.totals.totalPaid + this.totals.totalDiscount);
      });
      this.totals.totalPaid = total_paid;
      this.totals.totalAmount = total_amount;
      this.totals.totalDiscount = total_discount;
      this.totals.totalBalance = total_amount - (total_paid + total_discount)
    },
    ShowEdit(data) {
      this.edit.id = data.id;
      this.edit.name = data.customer + '-' + data.customerPhone;
      this.edit.pay_date = new Date(data.pay_date);
    },

    EditPayDate(modal) {
      this.SaveStatus = true;
      this.editPaydate(this.edit).then(() => {
        this.SaveStatus = false;
        this.FetchDebtors(this.data)
        this.closeModal(modal);
      });
    }
  },

  created() {
    this.FetchDebtors(this.data);
    this.FetchGeneralSettings();
    this.FetchReceiptSettings();
    this.FetchCustomers();
    this.FetchModes()
    this.setDefaultMode();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <h4 class="card-title text-center">Items Sold On Credit from {{ data.datefrom }} to {{ data.dateto }}</h4>
            </div>

            <div class="row">
              <div class="col-md-4"></div>
              <div class="col-md-4 mb-3" v-if="branchid == 0">
                <label>FILTER BY BRANCHES</label>
                <model-list-select :list="Branches ? [{ id: 0, name: 'All Branches' }, ...Branches] : []" v-model="data.branch_id" option-value="id"
                  option-text="name" placeholder="Select Branch" @input="filterReport()">
                </model-list-select>
              </div>
              <div v-else class="col-md-8" align="right">
                <router-link to="/sales/imported_debtors"><b-button variant="info">Imported Debtors</b-button></router-link>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label>From</label>
                  <input type="date" v-model="data.datefrom" class="form-control" />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>To</label>
                  <input type="date" v-model="data.dateto" class="form-control" />
                </div>
              </div>
              <div class="col-md-4 form-group">
                <label>CUSTOMERS</label>
                <model-list-select :list="Customers ? Customers : []" v-model="data.customer" option-value="id"
                  option-text="name" placeholder="Select Customer" @input="filterReport()">
                </model-list-select>
              </div>
              <div class="col-md-2 mt-4">
                <button class="btn btn-primary" type="button" @click="filterReport()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner v-show="filterStatus" variant="light" small role="status"></b-spinner>
                </button>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm"
                      :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table class="datatables" :items="Debtors ? Debtors : []"
                :fields="fields" responsive="sm" :per-page="perPage"
                :current-page="currentPage" :sort-desc.sync="sortDesc" :filter="filter"
                :filter-included-fields="filterOn" @filtered="onFiltered">
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(tt_amt)="data">
                  {{ (data.item.totalAmt).toLocaleString() }}
                </template>
                <template #cell(cust)="data">
                  {{ data.item.customerobj.name }}-{{ data.item.customerobj.contact }}
                </template>
                <template #cell(amt_paid)="data">
                  {{ (data.item.totalPaid).toLocaleString() }}
                </template>
                <template #cell(discount_field)="data">
                  {{ (data.item.discount).toLocaleString() }}
                </template>
                <template #cell(balance)="data">
                  {{ data.item.balance ? (data.item.balance).toLocaleString() : 0 }}
                </template>
                <template v-if="MyUserPerm.clear_debtors == 1 && branchid != 0" #cell(actions)="data">
                  <button @click="ShowClear(data.item)" class="btn btn-primary btn-sm" v-b-modal.clear-modal><i
                      class="fa fa-check"></i> Clear</button>
                </template>
                <template #cell(details)="data">
                  <table class="table">
                    <tbody>
                      <tr v-for="(det, d) in data.item.items" :key="d" width="100%">
                        <td>{{ det.product }}</td>
                        <td>{{ det.qty }}{{ det.usymbol }}</td>
                      </tr>
                    </tbody>
                  </table>
                </template>
                <template #cell(pay_date)="data">
                  <span class="text-warning" v-b-modal.edit_paydate-modal @click="ShowEdit(data.item)">{{ new
                    Date(data.item.pay_date).toISOString().split('T')[0] }}</span>
                </template>
                <template #cell(remaining_days)="data">
                  {{ Math.floor((new Date(data.item.pay_date) - new Date(new Date().toISOString().split('T')[0])) / (1000
                    * 60 * 60 * 24)) }} days
                </template>
              </b-table>
              <div class="row">
                <div class="col-md-3">
                  <h5>Total Amount: <span class="text-danger">{{ (totals.totalAmount).toLocaleString() }}</span></h5>
                </div>
                <div class="col-md-3">
                  <h5>Total Paid: <span class="text-danger">{{ (totals.totalPaid).toLocaleString() }}</span></h5>
                </div>
                <div class="col-md-3">
                  <h5>Total Discount: <span class="text-danger">{{ (totals.totalDiscount).toLocaleString() }}</span></h5>
                </div>
                <div class="col-md-3">
                  <h5>Total Balance: <span class="text-danger">{{ (totals.totalBalance).toLocaleString() }}</span></h5>
                </div>
              </div>
            </div>
            <Loader v-if="!Debtors" />
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Edit buying price modal starts -->
    <b-modal id="edit_paydate-modal" hide-footer>
      <template #modal-title>
        <h4 class="text-warning">Edit Pay Date for {{ edit.name }}'s debt'</h4>
      </template>
      <label>Expected Payment Date</label>
      <div class="input-group">
        <input type="date" class="form-control" v-model="edit.pay_date" placeholder="Expected Payment Date" />
      </div>


      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeModal('edit_paydate-modal')">
          <i class="fa fa-times"></i> Close
        </button>
        <button type="button" class="btn btn-warning" @click="EditPayDate('edit_paydate-modal')">
          <i class="fa fa-minus"></i> Confirm
          <b-spinner v-if="SaveStatus" variant="light" small label="Submiting"></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!-- modal mark as expired starts -->
    <b-modal id="clear-modal" hide-footer @hidden="resetModal()">
      <template #modal-title>
        <h4 class="text-warning">Clear Credit of {{ (clear.paid).toLocaleString() }}</h4>
      </template>
      <label>Amount Paid <span class="text-danger">*</span></label>
      <div class="input-group">
        <input type="text" class="form-control" v-model="clear.paid" placeholder="Amount Paid"
          @input="resetError(), addCommas(), checkAmt()" />
      </div>
      <div class="text-danger" v-if="amountError">
        <em>{{ amountError }}</em>
      </div>
      <div class="form-group">
        <label>Payment Method <span class="text-danger">*</span></label>
        <model-list-select :list="PaymentOptions ? PaymentOptions : []" v-model="clear.mode" option-value="id"
          option-text="mode" placeholder="Select Method" @input="resetError()">
        </model-list-select>
      </div>
      <div class="text-danger" v-if="modeError">
        <em>{{ modeError }}</em>
      </div>
      <label>Payment Date</label>
      <div class="input-group">
        <input type="date" class="form-control" v-model="clear.date" v-limit-future-date />
      </div>
      <div class="row mt-3">
        <div class="col-12 d-flex flex-column flex-md-row justify-content-between gap-2">

          <div class="w-100 w-md-auto">
            <button v-if="SaveStatus" type="button" class="btn btn-warning w-100" disabled>
              Confirm & Print
              <b-spinner variant="light" small label="Submitting"></b-spinner>
            </button>
            <button v-else type="button" class="btn btn-warning w-100" @click="clearAmtPrint('clear-modal')">
              Confirm & Print
            </button>
          </div>

          <div class="w-100 w-md-auto">
            <button v-if="SaveStatus" type="button" class="btn btn-warning w-100" disabled>
              Confirm & Exit
              <b-spinner variant="light" small label="Submitting"></b-spinner>
            </button>
            <button v-else type="button" class="btn btn-warning w-100" @click="clearAmt('clear-modal')">
              Confirm & Exit
            </button>
          </div>

        </div>
      </div>
    </b-modal>


  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #FAB031 !important;
  border-color: #FAB031 !important;
}
</style>